import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetchProfile as makeProfileRequest } from '@/utils/api/user';
import { type UserProfile } from '@/utils/api/schema/profileSchema';

export interface ProfileState {
  isLoading: boolean;
  profile?: UserProfile;
}

const initialState: ProfileState = {
  isLoading: true,
};

export const fetchProfile = createAsyncThunk<UserProfile>('fetchProfile', () =>
  makeProfileRequest().then((res) => res.profile),
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProfile.fulfilled, (state, action) => ({ profile: action.payload, isLoading: false }));
    builder.addCase(fetchProfile.rejected, (state, action) => {
      console.log(action.error);
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- might break smth, need a thorough check
      throw action.error;
    });
  },
});
